export const services = [
  {
    "id": 1,
    "category_id": 1,
    "title": "Вакцинация комплексная",
    "price": [
      {
        "cat": "",
        "cat_price_1": "от 2 800",
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 2,
    "category_id": 1,
    "title": "Вакцинация бешенство",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 3,
    "category_id": 1,
    "title": "Чипирование с занесением в базу Animal-ID",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2300,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 4,
    "category_id": 1,
    "title": "Паспорт животного",
    "price": [
      {
        "cat": "",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 5,
    "category_id": 2,
    "title": "Первичный прием врача(общий осмотр, назначение лечения)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1050,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 6,
    "category_id": 2,
    "title": "Первичный прием Завилохина Н.Г.",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 7,
    "category_id": 2,
    "title": "Повторный прием",
    "price": [
      {
        "cat": "",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 8,
    "category_id": 2,
    "title": "Повторный прием Завилохина Н.Г.",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 9,
    "category_id": 2,
    "title": "Консультация без животного",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 10,
    "category_id": 2,
    "title": "Консультация по результатам анализов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 11,
    "category_id": 2,
    "title": "Прием узкого специалиста",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 12,
    "category_id": 2,
    "title": "Инъекция(п/к, в/м)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 150,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 13,
    "category_id": 2,
    "title": "Инъекция(п/к, в/м) (по назначениям другой клиники)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 250,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 14,
    "category_id": 2,
    "title": "Внутривенная инъекция струйно",
    "price": [
      {
        "cat": "",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 15,
    "category_id": 2,
    "title": "Постановка в/в катетер",
    "price": [
      {
        "cat": "",
        "cat_price_1": 550,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 16,
    "category_id": 2,
    "title": "В/в капельно",
    "price": [
      {
        "cat": "",
        "cat_price_1": 700,
        "cat_price_2": "+300 каждый последующий час",
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 17,
    "category_id": 2,
    "title": "Ректальное введение",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 200,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 18,
    "category_id": 2,
    "title": "Пероральное введени",
    "price": [
        {
          "cat": "Кат 1",
          "cat_price_1": 200,
          "cat_price_2": 0,
          "cat_price_3": 0
        },
        {
          "cat": "Кат 2",
          "cat_price_1": 300,
          "cat_price_2": 0,
          "cat_price_3": 0
        },
        {
          "cat": "Кат 3",
          "cat_price_1": 400,
          "cat_price_2": 0,
          "cat_price_3": 0
        }
    ]
  },
  {
    "id": 19,
    "category_id": 2,
    "title": "Обработка глаз",
    "price": [
      {
        "cat": "",
        "cat_price_1": 200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 20,
    "category_id": 2,
    "title": "Наружная обработка",
    "price": [
        {
            "cat": "Кат 1",
            "cat_price_1": 250,
            "cat_price_2": 0,
            "cat_price_3": 0
          },
          {
            "cat": "Кат 2",
            "cat_price_1": 350,
            "cat_price_2": 0,
            "cat_price_3": 0
          },
          {
            "cat": "Кат 3",
            "cat_price_1": 600,
            "cat_price_2": 0,
            "cat_price_3": 0
          }
    ]
  },
  {
    "id": 21,
    "category_id": 2,
    "title": "Санация носовых ходов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 350,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 22,
    "category_id": 2,
    "title": "Санация ушного прохода",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 550,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 23,
    "category_id": 2,
    "title": "Взятие крови",
    "price": [
      {
        "cat": "",
        "cat_price_1": 550,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 24,
    "category_id": 2,
    "title": "Взятие крови у хорьков и кроликов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 850,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 25,
    "category_id": 2,
    "title": "Глюкозометрия",
    "price": [
      {
        "cat": "",
        "cat_price_1": 250,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 26,
    "category_id": 2,
    "title": "Тонометрия",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 27,
    "category_id": 2,
    "title": "Местная анестезия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 28,
    "category_id": 2,
    "title": "Циркулярная новокаиновая блокада",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 29,
    "category_id": 2,
    "title": "Люм.диагностика",
    "price": [
      {
        "cat": "",
        "cat_price_1": 250,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 30,
    "category_id": 2,
    "title": "Дарсонваль",
    "price": [
      {
        "cat": "",
        "cat_price_1": 200,
        "cat_price_2": "1 500 курс",
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 31,
    "category_id": 2,
    "title": "Взятие соскоба, мазка",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 32,
    "category_id": 2,
    "title": "Взятие цитологии",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 33,
    "category_id": 2,
    "title": "Фиксация животного",
    "price": [
      {
        "cat": "",
        "cat_price_1": 300,
        "cat_price_2": 500,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 34,
    "category_id": 2,
    "title": "Обработка ротовой полости",
    "price": [
      {
        "cat": "",
        "cat_price_1": 250,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 35,
    "category_id": 2,
    "title": "Пункция мочевого пузыря",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 36,
    "category_id": 2,
    "title": "Катетеризация мочевого пузыря без подшивания",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 37,
    "category_id": 2,
    "title": "Катетеризация мочевого пузыря с подшиванием",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 4500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 5500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 38,
    "category_id": 2,
    "title": "Промывание мочевого пузыря",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 39,
    "category_id": 2,
    "title": "Снятие в/в, уретрального катетера, швов(по назначениям другой клиники)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 40,
    "category_id": 2,
    "title": "Массаж мочевого пузыря",
    "price": [
      {
        "cat": "",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 41,
    "category_id": 2,
    "title": "Промывания препуция",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 200,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 42,
    "category_id": 2,
    "title": "Промывание полости",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 43,
    "category_id": 2,
    "title": "Вскрытие абсцесса, лечение флегмоны или гематомы",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 44,
    "category_id": 2,
    "title": "Гигиеническая чистка ушной раковины",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 45,
    "category_id": 2,
    "title": "Глубокая клизма (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 46,
    "category_id": 2,
    "title": "Глубокая клизма (собака до 25кг)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 4500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 47,
    "category_id": 2,
    "title": "Глубокая клизма (собака от 25кг)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 5500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 4500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 48,
    "category_id": 2,
    "title": "Механическое удаление каловых масс",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 49,
    "category_id": 2,
    "title": "Пункция брюшной полости",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 50,
    "category_id": 2,
    "title": "Пункция грудной полости",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 51,
    "category_id": 2,
    "title": "Лапароцентез с отведением под контролем УЗИ (без анестезии)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 9000,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 52,
    "category_id": 2,
    "title": "Удаление секрета ПАЖ (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 53,
    "category_id": 2,
    "title": "Торакоцентез с отведением под контролем УЗИ (без анестезии)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 9000,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 54,
    "category_id": 2,
    "title": "Цистоцентез",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 55,
    "category_id": 2,
    "title": "Удаление секрета ПАЖ (собака)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 56,
    "category_id": 2,
    "title": "Промывание ПАЖ",
    "price": [
      {
        "cat": "",
        "cat_price_1": 900,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 57,
    "category_id": 2,
    "title": "Удаление иксодового клеща",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 450,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 58,
    "category_id": 2,
    "title": "Родовспоможение",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2000,
        "cat_price_2": "+400 а каждый последующий час",
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 59,
    "category_id": 2,
    "title": "Реанимация новорожденных",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 60,
    "category_id": 2,
    "title": "Десмургия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 61,
    "category_id": 2,
    "title": "Стрижка когтей (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 350,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 62,
    "category_id": 2,
    "title": "Стрижка когтей (собака до 5кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 63,
    "category_id": 2,
    "title": "Стрижка когтей (собака до 25кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 450,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 64,
    "category_id": 2,
    "title": "Стрижка когтей (собака от 25кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 65,
    "category_id": 2,
    "title": "Обработка от эктопаразитов",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 200,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 66,
    "category_id": 2,
    "title": "Коррекция клюва",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 67,
    "category_id": 2,
    "title": "Коррекция зубов у грызунов",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 450,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 68,
    "category_id": 2,
    "title": "Удаление колтунов",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 69,
    "category_id": 2,
    "title": "Забор крови у донора (кошка) с учетом расходных материалов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 4000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 70,
    "category_id": 2,
    "title": "Забор крови у донора (собака) с учетом расходных материалов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 71,
    "category_id": 2,
    "title": "Осмотр+замер гематокрита у донора",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1300,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 72,
    "category_id": 2,
    "title": "Гемотранфузия кошки, собаки",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 4000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 73,
    "category_id": 2,
    "title": "Приготовление плазмы или эр. массы хозяйского донора с забром крови до 30мл/более (расходные материалы включены)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 74,
    "category_id": 2,
    "title": "Установка назогастрального зонда (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 75,
    "category_id": 2,
    "title": "Установка назогастрального зонда (собака)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 76,
    "category_id": 2,
    "title": "Зондирование желудка",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 77,
    "category_id": 2,
    "title": "Зондирование желудка с промыванием",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 78,
    "category_id": 3,
    "title": "Первичный прием хирурга",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 79,
    "category_id": 3,
    "title": "Повторный прием хирурга",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 80,
    "category_id": 3,
    "title": "Анестезиолог",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 81,
    "category_id": 4,
    "title": "Кастрация кота",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 82,
    "category_id": 4,
    "title": "Кастрация кота крипторха",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 83,
    "category_id": 4,
    "title": "Кастрация кобеля до 5кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 84,
    "category_id": 4,
    "title": "Кастрация кобеля от 5 до 10кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 85,
    "category_id": 4,
    "title": "Кастрация кобеля от 10 до 20кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 86,
    "category_id": 4,
    "title": "Кастрация кобеля от 20 до 30кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 87,
    "category_id": 4,
    "title": "Кастрация кобеля от 30 до 40кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 88,
    "category_id": 4,
    "title": "Кастрация кобеля от 40 до 50кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 89,
    "category_id": 4,
    "title": "Кастрация кобеля < 50кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 90,
    "category_id": 4,
    "title": "Кастрация кобеля крипторха",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 91,
    "category_id": 4,
    "title": "Удаление мошонки",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 92,
    "category_id": 4,
    "title": "Кастрация хорька, крысы",
    "price": [
      {
        "cat": "",
        "cat_price_1": 4500,
        "cat_price_2": 2500,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 93,
    "category_id": 4,
    "title": "Овариогистерэктомия (ОГЭ) кошки до 3-х лет (с учетом расходных материалов)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 94,
    "category_id": 4,
    "title": "Овариогистерэктомия (ОГЭ) кошки старше 3-х лет (с учетом расходных материалов)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 6500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 95,
    "category_id": 4,
    "title": "Овариогистерэктомия (ОГЭ) кошки до 3-х лет лапароскопическим способом (с учетом расходных материалов)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 96,
    "category_id": 5,
    "title": "ОГЭ суки до 5кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 97,
    "category_id": 5,
    "title": "ОГЭ суки от 5 до 10кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 98,
    "category_id": 5,
    "title": "ОГЭ суки от 10 до 20кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 13000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 99,
    "category_id": 5,
    "title": "ОГЭ суки от 20 до 30кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 100,
    "category_id": 5,
    "title": "ОГЭ суки от 30 до 40кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 101,
    "category_id": 5,
    "title": "ОГЭ суки от 40 до 50кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 25000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 102,
    "category_id": 5,
    "title": "ОГЭ хорьки, кролики",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 103,
    "category_id": 5,
    "title": "Общая анестезия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 104,
    "category_id": 5,
    "title": "Первичная хирургическая обработка раны",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 4000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 105,
    "category_id": 5,
    "title": "Повторная хирургическая обработка раны",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 2000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 106,
    "category_id": 5,
    "title": "Хирургическая обработка раны с дренированием",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 107,
    "category_id": 5,
    "title": "Замена дренажа",
    "price": [
      {
        "cat": "",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 108,
    "category_id": 5,
    "title": "Наложение шва (1 шов)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 200,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 400,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 109,
    "category_id": 5,
    "title": "Удаление новообразования",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 110,
    "category_id": 5,
    "title": "Удаление рудиментарного пальца до 10 дней",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 111,
    "category_id": 5,
    "title": "Удаление рудиментарного пальца > 10 дней",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 112,
    "category_id": 5,
    "title": "Ампутация хвоста",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 4500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 6500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 8500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 113,
    "category_id": 5,
    "title": "Ампутация фаланги пальца",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 4000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 114,
    "category_id": 5,
    "title": "Удаление инородных тел из ротовой полости",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 115,
    "category_id": 5,
    "title": "Трепанация носовых пазух (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 116,
    "category_id": 5,
    "title": "Трепанация носовых пазух (собака)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 117,
    "category_id": 5,
    "title": "Удаление слухового прохода",
    "price": [
      {
        "cat": "",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 118,
    "category_id": 5,
    "title": "Удаление ПАЖ",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 7500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 119,
    "category_id": 5,
    "title": "Удаление инородных тел из ЖКТ",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 120,
    "category_id": 5,
    "title": "Удаление Н/О мочевого пузыря",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 121,
    "category_id": 5,
    "title": "Вправление выпавшей прямой кишки",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 122,
    "category_id": 5,
    "title": "Вправление выпавшей прямой кишки с резекцией",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 123,
    "category_id": 5,
    "title": "Вправление выпавшей прямой кишки с фиксацией",
    "price": [
      {
        "cat": "",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 124,
    "category_id": 5,
    "title": "Оперативное лечение пролапса влагалища",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 125,
    "category_id": 5,
    "title": "Грыжесечение пупочная",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 126,
    "category_id": 5,
    "title": "Грыжесечение при промежностных грыжах одностороннее",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 127,
    "category_id": 5,
    "title": "Грыжесечение при паховых грыжах односторонее",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 128,
    "category_id": 5,
    "title": "Диагностическая лапаротомия (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 129,
    "category_id": 5,
    "title": "Диагностическая лапаротомия (собака от 5 до 25кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 130,
    "category_id": 5,
    "title": "Диагностическая лапаротомия (собака от 25кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 131,
    "category_id": 5,
    "title": "Заворот желудка",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 132,
    "category_id": 5,
    "title": "Кесарево сечение кошки",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 133,
    "category_id": 5,
    "title": "Кесарево сечение суки до 10 кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 16000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 134,
    "category_id": 5,
    "title": "Кесарево сечение собаке от 10 до 20кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 135,
    "category_id": 5,
    "title": "Кесарево сечение собаке от 20 до 30кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 136,
    "category_id": 5,
    "title": "Кесарево сечение собаке от 30 до 40кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 25000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 137,
    "category_id": 5,
    "title": "Кесарево сечение собаке от 40 до 50кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 30000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 138,
    "category_id": 5,
    "title": "Удаление пиометры кошки",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 139,
    "category_id": 5,
    "title": "Удаление пиометры суки до 10кг",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 140,
    "category_id": 5,
    "title": "Удаление пиометры суки от 10 до 20кг",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 141,
    "category_id": 5,
    "title": "Удаление пиометры суки < 20кг",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 25000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 28000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 142,
    "category_id": 5,
    "title": "Мастэктомия тотальная односторонняя",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 14000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 16000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 143,
    "category_id": 5,
    "title": "Спленэктомия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 17000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 144,
    "category_id": 5,
    "title": "Удаление доли печени",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 14000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 16000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 145,
    "category_id": 5,
    "title": "Гастротомия",
    "price": [
      {
        "cat": "",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 146,
    "category_id": 5,
    "title": "Резекция кишечника",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 147,
    "category_id": 5,
    "title": "Операция при диафрагмальной грыже",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 17000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 19000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 148,
    "category_id": 5,
    "title": "Уретростомия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 149,
    "category_id": 5,
    "title": "Цистостомия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 13000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 16000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 21000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 150,
    "category_id": 5,
    "title": "Энтеротомия",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 12000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 14000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 151,
    "category_id": 5,
    "title": "Химиотерапия 1 сеанс (кошка)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 152,
    "category_id": 5,
    "title": "Химиотерапия 1 сеанс (собака)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 153,
    "category_id": 5,
    "title": "Криодеструкция 1 сеанс",
    "price": [
      {
        "cat": "",
        "cat_price_1": 4500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 154,
    "category_id": 6,
    "title": "Вправление вывиха",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 155,
    "category_id": 6,
    "title": "Резекция головки бедра (кошка/собака до 5кг)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 158,
    "category_id": 6,
    "title": "Резекция головки бедра (собака от 5 до 25кг)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 20000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 157,
    "category_id": 6,
    "title": "Резекция головки бедра (кошка/собака от 25кг)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 21000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 23000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 25000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 158,
    "category_id": 6,
    "title": "Вывих коленной чашки при разрыве ПКС",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 18000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 22000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 25000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 28000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 159,
    "category_id": 6,
    "title": "Ампутация конечности",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 17000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 19000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 160,
    "category_id": 6,
    "title": "Металлоостеосинтез (кошка/собака до 5кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 19000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 161,
    "category_id": 6,
    "title": "Металлоостеосинтез (собака до 25кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 23000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 162,
    "category_id": 6,
    "title": "Металлоостеосинтез (собака от 25кг)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 26000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 163,
    "category_id": 6,
    "title": "Снятие металоконструкции",
    "price": [
      {
        "cat": "",
        "cat_price_1": 5000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 164,
    "category_id": 6,
    "title": "Снятие пластин",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 165,
    "category_id": 7,
    "title": "Санация ротовой полости (УЗ чистка+полировка)",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 3500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 4500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 4",
        "cat_price_1": 7500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 166,
    "category_id": 7,
    "title": "Удаление молочного зуба",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 167,
    "category_id": 7,
    "title": "Удаление коренного зуба",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 168,
    "category_id": 8,
    "title": "Тест Ширмера",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 169,
    "category_id": 8,
    "title": "Тест Джонса",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 170,
    "category_id": 8,
    "title": "Тест на целостность роговицы с флуоресценином",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 171,
    "category_id": 8,
    "title": "Энуклеация глазного яблока",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 15000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 172,
    "category_id": 8,
    "title": "Вправление глазного яблока",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 10000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 173,
    "category_id": 8,
    "title": "Пластика век",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 11000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 174,
    "category_id": 8,
    "title": "Коррекция пролапса слезной железы 3-го века",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 7000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 3",
        "cat_price_1": 8000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 175,
    "category_id": 8,
    "title": "Удаление инородного тела из конъюктивального мешка",
    "price": [
      {
        "cat": "Кат 1",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      },
      {
        "cat": "Кат 2",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 176,
    "category_id": 9,
    "title": "Микроскопия соскоба",
    "price": [
      {
        "cat": "",
        "cat_price_1": 500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 177,
    "category_id": 9,
    "title": "Микроскопия соскоба с окрашиванием",
    "price": [
      {
        "cat": "",
        "cat_price_1": 700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 178,
    "category_id": 9,
    "title": "УЗИ обзорное (брюшной полости)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3800,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 179,
    "category_id": 9,
    "title": "УЗИ одного органа",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1300,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 180,
    "category_id": 9,
    "title": "УЗИ мочеполовой системы",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 181,
    "category_id": 9,
    "title": "УЗИ желудочно-кишечного трактаы",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 182,
    "category_id": 9,
    "title": "УЗИ сердца предоперационное",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 183,
    "category_id": 9,
    "title": "УЗИ сердца",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 184,
    "category_id": 9,
    "title": "УЗИ грудной полости",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 185,
    "category_id": 9,
    "title": "УЗИ системы органов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 186,
    "category_id": 9,
    "title": "УЗИ матки (при беременности)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 187,
    "category_id": 9,
    "title": "ЭКГ исследование",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 188,
    "category_id": 9,
    "title": "Кислородная камера (1 час)",
    "price": [
      {
        "cat": "",
        "cat_price_1": 300,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 189,
    "category_id": 9,
    "title": "Анализ мочи",
    "price": [
      {
        "cat": "",
        "cat_price_1": 750,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 190,
    "category_id": 9,
    "title": "Анализ кала",
    "price": [
      {
        "cat": "",
        "cat_price_1": 900,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 191,
    "category_id": 10,
    "title": "",
    "price": [
      {
        "cat": "",
        "cat_price_1": "12 часов",
        "cat_price_2": "24 часа",
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 192,
    "category_id": 10,
    "title": "Неинфекционный*",
    "price": [
      {
        "cat": "",
        "cat_price_1": 400,
        "cat_price_2": 800,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 193,
    "category_id": 10,
    "title": "Инфекционный*",
    "price": [
      {
        "cat": "",
        "cat_price_1": 650,
        "cat_price_2": 1300,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 194,
    "category_id": 10,
    "title": "Интенсивная терапия*",
    "price": [
      {
        "cat": "",
        "cat_price_1": 700,
        "cat_price_2": 1500,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 195,
    "category_id": 10,
    "title": "  * без учета стоимости лечебных манипуляций, лекарств и расходных материалов",
    "price": [
      {
        "cat": "",
        "cat_price_1": 0,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 196,
    "category_id": 11,
    "title": "Кремация грызуна или животного до 1кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 600,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 197,
    "category_id": 11,
    "title": "Кремация животного до 5кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2200,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 198,
    "category_id": 11,
    "title": "Кремация животного от 5 до 10кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 2650,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 199,
    "category_id": 11,
    "title": "Кремация животного от 10 до 20кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3700,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 200,
    "category_id": 11,
    "title": "Кремация животного > 20кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 180,
        "cat_price_2": "за кг",
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 201,
    "category_id": 11,
    "title": "Эвтаназия (грызуны) до 5кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 202,
    "category_id": 11,
    "title": "Эвтаназия кошки/хорька/собаки до 5кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 1900,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 203,
    "category_id": 11,
    "title": "Эвтаназия собаки от 5 до 10кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 3000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 204,
    "category_id": 11,
    "title": "Эвтаназия собаки от 10 до 20кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 4000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 205,
    "category_id": 11,
    "title": "Эвтаназия собаки от 20 до 30кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 6000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 206,
    "category_id": 11,
    "title": "Эвтаназия собаки от 30 до 40кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 7500,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  },
  {
    "id": 207,
    "category_id": 11,
    "title": "Эвтаназия собаки от 40 до 50кг",
    "price": [
      {
        "cat": "",
        "cat_price_1": 9000,
        "cat_price_2": 0,
        "cat_price_3": 0
      }
    ]
  }
]